import { Person } from '../../../App/store/features/person/IPerson'
import { AppDispatch } from '../../../store'
import { updateBlockMoment } from '../../Events/utils/updateBlockMoment'
import {
  initialEventPositionChange,
  setEventPosition,
} from '../../store/calendarSlice'
import { getBlock } from '../../store/thunks/fetchBlock'
import { updateBlock } from '../../store/thunks/updateBlock'
import { ICalendarDay, IEvent, IEventCoordinates } from '../../types'
import { isInstanceOfIThunkError } from '../interfaceCheck'

export const blockCoordinateUpdate = (
  blockCategories: { [p: string]: ICalendarDay },
  event: IEvent,
  eventCoordinates: IEventCoordinates,
  filteredPersons: Person[],
  dispatch: AppDispatch,
) => {
  // Should be a simpler way of finding blockCatUuid
  const currentDay =
    blockCategories[event.startsAt.clone().format('YYYY-MM-DD')]
  if (typeof currentDay.blocks === 'undefined') {
    return
  }
  const blockedUuid = event.id.split('_')[0]
  const currentDayBlockFilter = currentDay.blocks.filter(
    block => block.uuid === blockedUuid,
  )
  const blockCategoryUuid = currentDayBlockFilter[0].blockedCategoryUuid
  const updateBlockData = updateBlockMoment(
    eventCoordinates,
    event,
    filteredPersons,
    blockCategoryUuid,
  )
  dispatch(
    updateBlock({
      data: updateBlockData,
      blockUuid: blockedUuid,
    }),
  ).then(({ payload }) => {
    if (typeof payload !== 'undefined' && !isInstanceOfIThunkError(payload)) {
      dispatch(
        setEventPosition({ eventPositionChange: initialEventPositionChange }),
      )
      dispatch(getBlock({ uuid: payload.blockUuid, type: 'update' }))
    }
  })
}
